import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";

const DEBT_COLORS = { border: "#f5c6cb", background: "#fdf1f2" };
const CREDIT_COLORS = { border: "#c3e6cb", background: "#edf7ef" };

const PlanillaBalanceTiles = ({ amounts, renderAmount }) => {
  const tiles = [
    {
      label: "Deuda total acumulada (sin este período)",
      value: amounts?.debt_other_periods,
      valueBs: amounts?.debt_other_periods_bs,
      ...DEBT_COLORS,
    },
    {
      label: "Deuda total acumulada (todos los períodos)",
      value: amounts?.debt_all_periods,
      valueBs: amounts?.debt_all_periods_bs,
      ...DEBT_COLORS,
    },
  ];

  if (Number(amounts?.credit_balance || 0) > 0) {
    tiles.push({
      label: "Saldo a favor",
      value: amounts?.credit_balance,
      valueBs: amounts?.credit_balance_bs,
      ...CREDIT_COLORS,
    });
  }

  return (
    <Row className="mx-n1 mb-2 text-center text-md-left">
      {tiles.map((tile) => (
        <Col
          key={tile.label}
          xs={12}
          md={12 / tiles.length}
          className="px-1 mb-2"
        >
          <div
            className="h-100 px-3 py-2"
            style={{
              border: `1px solid ${tile.border}`,
              backgroundColor: tile.background,
              borderRadius: "6px",
            }}
          >
            <div className="fs--1 text-700 font-weight-semi-bold mb-0">
              {tile.label}
            </div>
            {renderAmount(tile.value, tile.valueBs)}
          </div>
        </Col>
      ))}
    </Row>
  );
};

PlanillaBalanceTiles.propTypes = {
  amounts: PropTypes.object,
  renderAmount: PropTypes.func.isRequired,
};

export default PlanillaBalanceTiles;
